import * as Yup from 'yup';
import { CommonMessages } from 'src/validation/CommonMessages';

const ScheduleEditValidationSchema = Yup.object().shape({

    work_start_time: Yup.string()
    .required(CommonMessages.required('Work Start Time')),

    work_date: Yup.string()
    .required(CommonMessages.required('Work Date')),

    daily_memo: Yup.string()
    .required(CommonMessages.required('Daily Memo')),
    tasks: Yup.array().of(
        Yup.object().shape({
            holiday_cd: Yup.number().nullable(),
            memo: Yup.string()
            .required(CommonMessages.required("memo")) // Common required message
            .max(200, CommonMessages.maxLength("memo", 200)), // Example: max length
            progress_rate: Yup
            .number()
            .transform((value) => (isNaN(value) ? undefined : value))
            .min(0, "Progress must be at least 0%")
            .max(100, "Progress cannot exceed 100%")
            .required("Progress is required"),
        })
    ),
    }).test(
        'tasks-or-holiday',
        'Please Select Task or Holiday Area.',
        (value) => {
            const tasks = value.tasks || [];
            const holidayArea = value.holidayArea || [];
            return tasks.length > 0 || holidayArea.length > 0;
        }
    ).test(
        "total-progress",
        "Total progress of non-holiday tasks must be 100%",
        function (value) {
            const tasks = value.tasks || [];
            const totalProgress = tasks.reduce(
                (sum, task) => sum + (task.progress_rate || 0),
                0
            );
            return totalProgress === 100;
        }
    );
    
    export default ScheduleEditValidationSchema;